import React, { useEffect, useState } from 'react';
import {
  Grid,
  styled,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Paper,
  Button,
  Typography
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PageHeader from '../../../components/PageHeader';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Area } from '../../../schema/area';
import { api } from '../../../api';
import AreaZoneFromInput from '../../../components/formInput/AreaZoneFromInput';

const EditArea: React.FC = () => {
  const navigate = useNavigate();
  const { area_id } = useParams();

  const [code, setCode] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [zoneId, setZoneId] = useState<number | null>(null);

  const [isRequireWPM, setIsRequireWPM] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (area_id && name) {
      setIsLoading(true);
      api
        .put(`/area/${area_id}`, {
          area_name: name,
          area_code: code,
          is_require_wpm: isRequireWPM,
          zone_id: zoneId
        })
        .then(() => {
          navigate('/area');
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleDelete = () => {
    if (isLoading) {
      return;
    }
    if (area_id) {
      setIsLoading(true);
      api
        .delete(`/area/${area_id}`)
        .then(() => {
          navigate('/area');
        })
        .finally(() => setIsLoading(false));
    }
  };

  useEffect(() => {
    api.get<Area>(`/area/${area_id}`).then((res) => {
      const { data } = res;
      setName(data.area_name);
      setCode(data.area_code);
      setIsRequireWPM(data.is_require_wpm);
      data.zone_id && setZoneId(data.zone_id);
    });
  }, []);

  return (
    <RootContainer>
      <PageHeader text="แก้ไขพื้นที่" />

      <Button component={Link} to="/area" sx={{ my: 3, p: 0 }} >
        <ArrowBackIosIcon />
        พื้นที่
      </Button>

      <Paper>
        <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
          {'แก้ไขข้อมูล'}
        </Typography>

        <Form onSubmit={handleFormSubmit} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="รหัสพื้นที่"
                variant="outlined"
                placeholder="รหัสพื้นที่"
                onChange={(e) => setCode(e.target.value ? e.target.value : '')}
                value={code}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชื่อพื้นที่"
                variant="outlined"
                placeholder="ชื่อพื้นที่"
                onChange={(e) => setName(e.target.value ? e.target.value : '')}
                value={name}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <AreaZoneFromInput value={zoneId} onChange={(value) => setZoneId(value)} required />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="is_require_wpm">ต้องการ work permit</InputLabel>
                <Select
                  labelId="is_require_wpm"
                  label="ต้องการ work permit"
                  variant="outlined"
                  onChange={(e) => setIsRequireWPM(e.target.value == 'true')}
                  value={`${isRequireWPM}`}
                  autoComplete="off"
                >
                  <MenuItem value="true">ต้องการ</MenuItem>
                  <MenuItem value="false">ไม่ต้องการ</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container columns={2} spacing={2} direction={'row-reverse'}>
            <Grid item>
              <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 4 }}>
                แก้ไข
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="error"
                sx={{ marginTop: 4 }}
                onClick={handleDelete}
              >
                ลบ
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Paper>
    </RootContainer>
  );
};

export default EditArea;

const RootContainer = styled('div')`
  padding: 24px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
